import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { ExportFormat, ISharePointPrincipalCollectionBase, IUser } from "../models/auto-generated";
import { parseErrorBlob } from "../utils";

@Injectable({
  providedIn: "root"
})
export class UserMappingService {
  private getBaseRoute(instanceId: string, connectionId: string | number): string {
    return `/api/configurations/${instanceId}/sharepoint/${connectionId}/user-mapping`;
  }

  constructor(private http: HttpClient) {}

  get(instanceId: string, connectionId: string | number): Observable<IUser[]> {
    const baseRoute = this.getBaseRoute(instanceId, connectionId);
    return this.http.get<IUser[]>(baseRoute);
  }

  getPrincipals(instanceId: string, connectionId: string | number): Observable<ISharePointPrincipalCollectionBase> {
    const baseRoute = this.getBaseRoute(instanceId, connectionId);
    return this.http.get<ISharePointPrincipalCollectionBase>(`${baseRoute}/principals`);
  }

  getUsers(instanceId: string, connectionId: string | number): Observable<ISharePointPrincipalCollectionBase> {
    const baseRoute = this.getBaseRoute(instanceId, connectionId);
    return this.http.get<ISharePointPrincipalCollectionBase>(`${baseRoute}/users`);
  }

  export(instanceId: string, connectionId: string | number, format: ExportFormat): Observable<Blob> {
    const baseRoute = this.getBaseRoute(instanceId, connectionId);
    const params = new HttpParams().append("format", format);
    return this.http.post(`${baseRoute}/export`, {}, { params: params, responseType: "blob" }).pipe(catchError(parseErrorBlob));
  }
}
